import { render, staticRenderFns } from "./addTourRegister.vue?vue&type=template&id=68464eb2&scoped=true&"
import script from "./addTourRegister.vue?vue&type=script&lang=js&"
export * from "./addTourRegister.vue?vue&type=script&lang=js&"
import style0 from "./addTourRegister.vue?vue&type=style&index=0&id=68464eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68464eb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68464eb2')) {
      api.createRecord('68464eb2', component.options)
    } else {
      api.reload('68464eb2', component.options)
    }
    module.hot.accept("./addTourRegister.vue?vue&type=template&id=68464eb2&scoped=true&", function () {
      api.rerender('68464eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/component/addTourRegister.vue"
export default component.exports